import React from "react";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const rows = [
  {
    label: "Time to close",
    traditional: "Often 3-12+ months on the open market",
    partnership: "Typically 30-60 days once a buyer is lined up",
  },
  {
    label: "Upfront costs",
    traditional: "Agent commissions, staging, and repairs",
    partnership: "$0 out of pocket — we cover marketing and closing costs",
  },
  {
    label: "Your involvement",
    traditional: "You handle showings, negotiations, and paperwork",
    partnership: "We handle marketing, negotiations, and closing",
  },
  {
    label: "Buyer reach",
    traditional: "Limited to buyers who find your local listing",
    partnership: "Our buyer network across Texas markets",
  },
  {
    label: "Risk if it stalls",
    traditional: "Price cuts and carrying costs while it sits",
    partnership: "Terms are locked in together before you commit",
  },
];

const JVComparison = () => (
  <section className="bg-white py-14 sm:py-20">
    <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
      <div className="mb-10 text-center sm:mb-14">
        <p className="text-xs font-semibold uppercase tracking-wide text-[#C1694F] sm:text-sm">
          See The Difference
        </p>
        <h2 className="mt-2 text-2xl font-bold text-[#16213E] sm:text-4xl">
          Traditional Sale vs. Joint Venture
        </h2>
      </div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
        className="grid gap-4 sm:gap-6 md:grid-cols-2"
      >
        {/* Traditional column */}
        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 sm:p-8">
          <h3 className="mb-6 text-lg font-semibold text-slate-500">
            Selling It Yourself
          </h3>
          <ul className="space-y-4">
            {rows.map((row) => (
              <li key={row.label} className="flex items-start gap-3">
                <X className="mt-0.5 h-5 w-5 shrink-0 text-slate-400" />
                <div>
                  <p className="text-sm font-semibold text-slate-500">{row.label}</p>
                  <p className="text-sm text-slate-500">{row.traditional}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Joint venture column */}
        <div className="relative rounded-2xl border-2 border-[#C1694F] bg-[#16213E] p-6 shadow-lg sm:p-8">
          <span className="absolute -top-3 right-6 rounded-full bg-[#C1694F] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white">
            With Landivo
          </span>
          <h3 className="mb-6 text-lg font-semibold text-white">
            Partnering With Us
          </h3>
          <ul className="space-y-4">
            {rows.map((row) => (
              <li key={row.label} className="flex items-start gap-3">
                <Check className="mt-0.5 h-5 w-5 shrink-0 text-[#C1694F]" />
                <div>
                  <p className="text-sm font-semibold text-white">{row.label}</p>
                  <p className="text-sm text-slate-300">{row.partnership}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </motion.div>
    </div>
  </section>
);

export default JVComparison;
